import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import PersonalSectionStart from './index';
import { SectionStatus } from '../../../sections/types';
import { IProps } from '.';

const mapStateToProps = (state: ApplicationState): IProps => {
  const historyStarted = state.student.offer.isHSectionStarted;
  const consentsStarted = state.student.consents.isSectionStarted;
  const financeStarted = state.student.financials.isSectionStarted;

  const historyComplete = state.student.offer.isHSectionComplete;
  const consentsComplete = state.student.consents.isSectionComplete;
  const financeComplete = state.student.financials.isSectionComplete;

  return {
    title: state.student.config.Checklist.PersonalInfo.shortTitle,
    warning: state.student.config.Checklist.PersonalInfo.SectionStart.warning,
    historyStatus: historyComplete
      ? SectionStatus.complete
      : historyStarted
        ? SectionStatus.incomplete
        : SectionStatus.empty,
    consentsStatus: consentsComplete
      ? SectionStatus.complete
      : consentsStarted
        ? SectionStatus.incomplete
        : SectionStatus.empty,
    financeStatus: financeComplete
      ? SectionStatus.complete
      : financeStarted
        ? SectionStatus.incomplete
        : SectionStatus.empty,
  };
};

export default connect(mapStateToProps)(PersonalSectionStart);
